
import { ButtonContainer } from "./button.styled";
import { ButtonProps } from "./button.props";
import { CSSProperties, useEffect, useState } from "react";

const AGButton: React.FC<ButtonProps> = ({
    type,
    icon,
    style: styles,
    clasNameCus,
    ...props
}) => {
    const [style, setStyle] = useState<CSSProperties>();


    useEffect(() => {
        switch (type) {
            case "Primary":
                setStyle({
                    background: "#2C76AA",
                    color: "#ffffff",
                    borderColor: "#2C76AA",
                });
                break;
            case "Secondary":
                setStyle({
                    background: "#6B6B6B",
                    color: "#ffffff",
                    borderColor: "#6B6B6B",
                });
                break;
            case "Danger":
                setStyle({
                    background: "#E12626",
                    color: "#ffffff",
                    borderColor: "#E12626",
                });
                break;
            case "Success":
                setStyle({
                    background: "#03A100",
                    color: "#ffffff",
                    borderColor: "#03A100",
                });
                break;
            case "Light":
                setStyle({
                    background: "#ffffff",
                    color: "hsl(0, 0%, 20%)",
                    borderColor: "hsl(0, 0%, 20%)",
                });
                break;
            case "Normal":
                setStyle({
                    background: "#ffffff",
                    borderColor: "#ffffff",
                    color: "#58585B",
                });
                break;
            case "Link":
                setStyle({
                    background: "transparent",
                    color: "#2C76AA",
                    borderColor: "#2C76AA",
                    // borderBottom: "1px solid",
                });
                break;
            case "InLink":
                setStyle({
                    background: "transparent",
                    color: "#2C76AA",
                    borderColor: "transparent",
                    // borderBottom: "1px solid",
                });
                break;
            case "Icon":
                setStyle({
                    background: "transparent",
                    color: "#transparent",
                    borderColor: "transparent",
                });
                break;
            default:
                break;
        }
    }, [type]);

    if (!style) {
        return null;
    }

    return <ButtonContainer
        type="button"
        {...props}
        style={{
            fontSize: 14,
            borderRadius: type !== "Link" ? 7 : 0,
            border: type !== "Link" ? "1px solid" : "unset",
            padding: type !== "Link" ? "5px 6px" : "0",
            ...style,
            ...styles
        }}
    >
        {icon && <div>{icon}</div>}
        <div className={clasNameCus} style={{
            borderBottom: type === "Link" ? "1px solid #2C76AA" : type === "InLink" ? "0px solid #2C76AA" : "unset",
        }}>{props.children}</div>
    </ButtonContainer>
};

export default AGButton;
